(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useEffect, useCallback, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import debounce from "just-debounce";
import qs from "qs";
import { useDispatch, useSelector } from "../../../store";
import useQueryParams from "../../../hooks/useQueryParams";
import useSubscribeUrlParams from "./hooks/useSubscribeUrlParams";
import { fetchHistory, fetchHsCodes, setCountryCode } from "../state/actions";
import { selectors as appSelector } from "../../App";
import { countriesSelector, historySelector } from "../state/selectors";
import SearchBox from "../components/SearchBox";
import useLanguage from "../../Translation/hooks/useLanguage";

const useAppConfig = config => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (config.countryCode) {
      dispatch(setCountryCode(config.countryCode));
    }
  }, [config.countryCode, dispatch]);
};

__signature__(useAppConfig, "useDispatch{dispatch}\nuseEffect{}", () => [useDispatch]);

const SearchBoxContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const countries = useSelector(countriesSelector);
  const config = useSelector(appSelector.configSelector);
  const [params, setQueryParams] = useQueryParams();
  const searchHistory = useSelector(historySelector);
  const {
    dir
  } = useLanguage();
  const debounceFetchHSCodesRef = useRef(debounce(_ref => {
    let {
      searchString,
      countryCode: cCode
    } = _ref;
    dispatch(fetchHsCodes({
      searchString,
      countryCode: cCode,
      onShowError: config.onShowError
    }));
  }, 400));
  useAppConfig(config);
  useSubscribeUrlParams(["q", ...(config.countryCode ? [] : ["country"])]);
  const findHistory = useCallback(() => {
    dispatch(fetchHistory());
  }, [dispatch]);
  const onSearch = useCallback(_ref2 => {
    let {
      searchString,
      countryCode: cCode
    } = _ref2;
    if (!searchString) return;
    setQueryParams({
      q: searchString,
      ...(config.countryCode ? {} : {
        country: cCode
      })
    });

    if (!location.pathname.match(/\/search$/)) {
      var _pathname;

      let pathname = location.pathname.replace(/\/search\/\d+\/?$/, "").replace(/^\/$/, "");
      const lastSlashIndex = pathname.lastIndexOf("/");

      if (lastSlashIndex === ((_pathname = pathname) === null || _pathname === void 0 ? void 0 : _pathname.length) - 1) {
        pathname = pathname.substring(0, lastSlashIndex) + pathname.substring(lastSlashIndex + 1);
      }

      navigate({
        pathname: "".concat(pathname, "/search"),
        search: qs.stringify({
          q: searchString,
          ...(config.countryCode ? {} : {
            country: cCode
          })
        }, {
          addQueryPrefix: true
        })
      }, {
        state: {
          action: "PUSH"
        }
      });
    } else {
      debounceFetchHSCodesRef.current({
        searchString,
        countryCode: cCode
      });
    }
  }, [config.countryCode, location, navigate, setQueryParams]);
  return /*#__PURE__*/React.createElement(SearchBox, {
    countries: countries,
    countryCode: config.countryCode || params.country,
    searchString: params.q,
    searchHistory: searchHistory,
    onSearch: onSearch,
    findHistory: findHistory,
    withCountrySelect: !config.countryCode,
    languageDir: dir,
    onChangeCountry: config.onChangeCountry
  });
};

__signature__(SearchBoxContainer, "useLocation{location}\nuseNavigate{navigate}\nuseDispatch{dispatch}\nuseSelector{countries}\nuseSelector{config}\nuseQueryParams{[params, setQueryParams]}\nuseSelector{searchHistory}\nuseLanguage{{ dir }}\nuseRef{debounceFetchHSCodesRef}\nuseAppConfig{}\nuseSubscribeUrlParams{}\nuseCallback{findHistory}\nuseCallback{onSearch}", () => [useLocation, useNavigate, useDispatch, useSelector, useSelector, useQueryParams, useSelector, useLanguage, useAppConfig, useSubscribeUrlParams]);

const _default = /*#__PURE__*/React.memo(SearchBoxContainer);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useAppConfig, "useAppConfig", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/SearchBoxContainer.jsx");
  reactHotLoader.register(SearchBoxContainer, "SearchBoxContainer", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/SearchBoxContainer.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/SearchBoxContainer.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();